<template>
  <div class="tasks-list-row">
    <v-list-group :prepend-icon="letfIcon" append-icon="none" no-action v-model="selected">
      <div class="details">
        <div class="feature" v-for="feature in item.features" :key="feature.id">
          <!-- <custom-checkbox
            :value="item.features.some(f => f.name === $pt('newProject.resources.feature', feature))"
            color="light-green"
            class="disabled"
          /> -->
          <span class="feature-name">{{ $pt('newProject.resources.feature', feature.name) }}</span>
        </div>
      </div>
      <v-list-item slot="activator">
        <v-list-item-content>
          <div class="row">
            <span class="resource-index">{{ itemIndex }}</span>
            <custom-checkbox
              :disabled="changeStatusDisabled"
              :value="finished"
              color="light-green"
              @click.native="onChecked"
            />
            <span class="resource-name">{{ item.name }}</span>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { userRoleGroups } from '@/constants/auth';
import { projectStatuses, FEATURES_LIST, TASK_STATUSES } from '@/constants/projects';

import { UPDATE_TASKS } from '@/store/task/actionTypes';
import { LOAD_DETAILED_PROJECT } from '@/store/project/actionTypes';

import CustomCheckbox from '@/components/common/CustomCheckbox.vue';

export default {
  name: 'TaskListRow',
  components: {
    CustomCheckbox,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selected: false,
  }),
  computed: {
    ...mapGetters(['userRoleGroup']),
    letfIcon() {
      return this.selected ? 'arrow_drop_down' : 'arrow_right';
    },
    finished() {
      return this.item.task?.status === TASK_STATUSES.finished;
    },
    allFeatures() {
      return FEATURES_LIST;
    },
    changeStatusDisabled() {
      return this.userRoleGroup === userRoleGroups.CISO || this.project.status !== projectStatuses.IN_PROGRESS;
    },
  },
  methods: {
    async onChecked(e) {
      if (!this.changeStatusDisabled) {
        e.stopPropagation();
        const status = this.finished ? TASK_STATUSES.active : TASK_STATUSES.finished;
        await this.$store.dispatch(UPDATE_TASKS, {
          projectId: this.project.id,
          tasks: [{ projectResourceId: this.item.id, status }],
        });
        await this.$store.dispatch(LOAD_DETAILED_PROJECT, this.project.id);
      }
    },
  },
};
</script>

<style lang="scss">
.tasks-list-row {
  .v-list-group__header {
    padding: 0px;
  }

  .v-list-item__icon.v-list-group__header__prepend-icon {
    margin: 8px 0px !important;
    align-self: center;
  }

  .v-list-item__content {
    padding: 0px;
  }

  .v-list-item {
    padding: 0px;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.row {
  display: flex;
  padding: 0px $space-3;

  .resource-index {
    color: var(--text-tertiary);
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: $space-5;
    margin-right: 44px;
  }

  .resource-name {
    color: var(--text-primary);
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: $space-5;
  }

  .checkbox-container {
    margin-right: 26px;
  }
}

.tasks-list-row {
  .details {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    max-width: 450px;
    flex-wrap: wrap;
    margin: 0px 133px;
    padding: 0px $space-4;
    padding-bottom: $space-2-5;
    width: auto;
    box-sizing: border-box;
    border: 1px solid rgba(159, 165, 180, 0.5);
    background-color: var(--bg-primary);

    .feature {
      display: flex;
      width: 200px;
      height: $font-size-lg;
      margin-top: $space-2-5;

      .feature-name {
        color: var(--text-primary);
        font-size: $font-size-sm;
        letter-spacing: 0;
        line-height: $font-size-md;
      }

      .disabled {
        cursor: default;
      }
    }
  }
}
</style>
